import _ from 'lodash';

/* @ngInject */
export default function WeatherPanelService($q, $log, EquipmentInfoService) {
  const service = this;

  /**
   * Public Variables
   */
  service.weatherPanelModel = {};

  /**
   * Public Methods
   */
  service.getWeatherPanelModel = getWeatherPanelModel;
  service.deleteModel = deleteModel;

  EquipmentInfoService.setNeed('admin_equipment');

  function getWeatherPanelModel(equipmentIds, currentPanel) {
    return EquipmentInfoService.getEquipmentById(equipmentIds)
      .then((equipment) => {
        service.weatherPanelModel[currentPanel.id] = {
          equipment: [],
          eventCounter: {}
        };
        _.forEach(equipment, (item) => {
          service.weatherPanelModel[currentPanel.id].eventCounter[item.id] = 0;
          EquipmentInfoService.getHoursRemaining(item);
          service.weatherPanelModel[currentPanel.id].equipment.push(item);
        });

        return service.weatherPanelModel[currentPanel.id];
      })
      .catch((error) => {
        $log.error('Error: ', error);
        return $q.reject(error);
      });
  }

  function deleteModel(panelId) {
    if (_.has(service.weatherPanelModel, panelId)) {
      delete service.weatherPanelModel[panelId];
    }
  }
}
